import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import foldericon from '@iconify/icons-eva/people-fill';
import repeatfill from '@iconify/icons-eva/repeat-fill';
import starfill from '@iconify/icons-eva/star-fill';
import bookfill from '@iconify/icons-eva/book-open-outline';
import ratefill from '@iconify/icons-eva/bar-chart-fill';
import leaguesicon from '@iconify/icons-eva/award-outline';
import dictionaryicon from '@iconify/icons-eva/book-fill';
import sentencestructureicon from '@iconify/icons-eva/grid-outline';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Home',
    path: '/dashboard/home',
    icon: getIcon(pieChart2Fill)
  },
  {
    title: 'Sentence Structure',
    path: '/dashboard/wordlist/0/sentence-structure',
    icon: getIcon(sentencestructureicon)
  },
  {
    title: 'Dictionary',
    path: '/dashboard/dictionary',
    icon: getIcon(dictionaryicon)
  },
  {
    title: 'Folders',
    path: '/dashboard/folders',
    icon: getIcon(foldericon)
  },
  {
    title: 'Need repeat',
    path: '/dashboard/need-repeat',
    icon: getIcon(repeatfill)
  },
  {
    title: 'Saved words',
    path: '/dashboard/folder/saved',
    icon: getIcon(starfill)
  },
  {
    title: 'Books',
    path: '/dashboard/books',
    icon: getIcon(bookfill)
  },
  {
    title: 'Leaderboard',
    path: '/dashboard/leaderboard',
    icon: getIcon(ratefill)
  },
  {
    title: 'Leagues',
    path: '/dashboard/leagues',
    icon: getIcon(leaguesicon)
  }
];

export default sidebarConfig;
